class SybilLifestylePlayer extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.abortController = new AbortController();
    this.video = this.querySelector('[data-sybil-lifestyle-video]');
    this.playButton = this.querySelector('[data-sybil-lifestyle-play]');
    if (!(this.video instanceof HTMLVideoElement) || !(this.playButton instanceof HTMLElement)) {
      return;
    }

    const { signal } = this.abortController;
    this.playButton.addEventListener('click', () => this.start(), { signal });
    this.video.addEventListener('play', () => {
      this.dataset.started = 'true';
      this.video.controls = false;
    }, { signal });
    this.video.addEventListener('ended', () => {
      this.dataset.started = 'false';
      this.video.controls = false;
    }, { signal });
    this.addEventListener('pointerenter', () => {
      if (this.dataset.started === 'true') this.video.controls = true;
    }, { signal });
    this.addEventListener('pointerleave', () => {
      if (this.dataset.started === 'true') this.video.controls = false;
    }, { signal });
    this.addEventListener('focusin', () => {
      if (this.dataset.started === 'true') this.video.controls = true;
    }, { signal });
    this.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!this.contains(document.activeElement) && this.dataset.started === 'true') {
          this.video.controls = false;
        }
      });
    }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = undefined;
  }

  async start() {
    try {
      await this.video.play();
      this.dataset.started = 'true';
    } catch {
      this.dataset.started = 'false';
    }
  }
}

if (!customElements.get('sybil-lifestyle-player')) {
  customElements.define('sybil-lifestyle-player', SybilLifestylePlayer);
}
